import { call, put, select, takeLatest } from 'redux-saga/effects';
import _ from 'lodash';
import Log from '../../utils/Debug';

/* eslint-disable arrow-body-style */
import {
  MEDIA_BROWSER_FETCH_LIST,
  MEDIA_BROWSER_FETCH_ITEM,
  MEDIA_BROWSER_FETCH_LIST_ERROR,
} from './mediaBrowserConstants';

import {
  fetchMediaListAction,
  fetchMediaListErrorAction,
  fetchMediaListLoadingAction,
  fetchMediaListSuccessAction,
  fetchMediaItemAction,
  fetchMediaItemErrorAction,
  fetchMediaItemLoadingAction,
  fetchMediaItemSuccessAction,
} from './mediaBrowserReducers';

export default (bottle) => {
  bottle.factory('mediaBrowserFetchListSaga', ({ fetchMediaList }) => {
    return function* mediaBrowserFetchListSaga() {
      yield takeLatest(MEDIA_BROWSER_FETCH_LIST, fetchMediaList);
    };
  });

  bottle.factory('mediaBrowserFetchItemSaga', ({ fetchMediaItem }) => {
    return function* mediaBrowserFetchItemSaga() {
      yield takeLatest(MEDIA_BROWSER_FETCH_ITEM, fetchMediaItem);
    };
  });

  bottle.factory('fetchMediaList', ({ mediaBrowserFetchMediaList }) => {
    return function* fetchMediaList() {
      yield put(fetchMediaListLoadingAction(0));
      try {
        const [token] = yield select(state => [
          _.get(state, 'users.idToken'),
        ]);
        if (!token) {
          yield put({ type: MEDIA_BROWSER_FETCH_LIST_ERROR, error: 'Ephemeral Bearer Token is not available' });
          return;
        }
        const response = yield call(mediaBrowserFetchMediaList, token);
        const allMedia = _.get(response, 'data.media');
        if (Array.isArray(allMedia) && allMedia.length > 0) {
          yield put(fetchMediaListSuccessAction(allMedia));
        } else {
          yield put(fetchMediaListErrorAction('Unable to fetch media'));
        }
      } catch (err) {
        Log.error('fetchMedia error:', err);
        yield put(fetchMediaListErrorAction(err));
      }
    };
  });

  bottle.factory('fetchMediaItem', ({ mediaBrowserFetchMediaItem }) => {
    return function* fetchMediaItem() {
      yield put(fetchMediaItemLoadingAction(0));
      try {
        const [mediaId, token] = yield select((state) => {
          return [
            _.get(state, 'mediaBrowser.mediaId'),
            _.get(state, 'users.idToken'),
          ];
        });
        if (!token || !mediaId) {
          yield put({
            type: MEDIA_BROWSER_FETCH_LIST_ERROR,
            error: 'Ephemeral Bearer Token or Media ID is not available',
          });
          return;
        }
        // const response = yield call(mediaBrowserFetchMediaItem, token, mediaId);
        // console.log('-------------- response ------------', response);
        // const currentMedia = _.get(response, 'data.mediaId');
        // console.log('-------------- currentMedia ------------', currentMedia);

        if (mediaId && mediaId.length > 0) {
          yield put(fetchMediaItemSuccessAction(mediaId, token));
        } else {
          yield put(fetchMediaItemErrorAction('Unable to fetch media'));
        }
      } catch (err) {
        Log.error('fetchMedia error:', err);
        yield put(fetchMediaItemErrorAction(err));
      }
    };
  });
};
